import { render } from "./instagram.vue?vue&type=template&id=10a379dc"
const script = {}

import exportComponent from "/usr/local/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__